/* eslint-disable */
import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// Professional color scheme
const COLORS = {
  primary: "#f59e0b",
  primaryLight: "#fef3c7",
  primaryDark: "#d97706",
  secondary: "#3b82f6",
  success: "#10b981",
  error: "#ef4444",
  dark: "#111827",
  gray: "#6b7280",
  lightGray: "#f9fafb",
  border: "#e5e7eb",
  white: "#ffffff",
};

const styles = StyleSheet.create({
  page: {
    padding: 40,
    backgroundColor: COLORS.white,
    fontFamily: "Helvetica",
  },

  // Header Section
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 30,
    paddingBottom: 20,
    borderBottom: `2px solid ${COLORS.primary}`,
  },
  logoArea: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  logoBox: {
    width: 50,
    height: 50,
    backgroundColor: COLORS.primaryLight,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  logoText: {
    fontSize: 24,
    fontWeight: "bold",
    color: COLORS.primary,
  },
  companyNameText: {
    fontSize: 18,
    fontWeight: "bold",
    color: COLORS.dark,
  },
  companySubText: {
    fontSize: 8,
    color: COLORS.gray,
    marginTop: 2,
  },
  titleArea: {
    alignItems: "flex-end",
  },
  payslipTitle: {
    fontSize: 24,
    fontWeight: "bold",
    color: COLORS.primary,
    letterSpacing: 1,
  },
  payslipMonth: {
    fontSize: 10,
    color: COLORS.gray,
    marginTop: 4,
  },

  // Compact Info Table
  infoTable: {
    marginBottom: 25,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    overflow: "hidden",
  },
  infoRow: {
    flexDirection: "row",
    borderBottom: `1px solid ${COLORS.border}`,
  },

  infoLabel: {
    fontSize: 9,
    color: COLORS.gray,
    fontWeight: "bold",
  },

  infoValue: {
    fontSize: 9,
    color: COLORS.dark,
  },

  lastRow: {
    borderBottom: "none",
  },

  // Status Badge
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    alignSelf: "flex-start",
  },
  statusText: {
    fontSize: 8,
    fontWeight: "bold",
  },

  // Salary Sections Title
  sectionTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: COLORS.dark,
    marginBottom: 12,
    paddingLeft: 8,
    borderLeft: `3px solid ${COLORS.primary}`,
  },

  // Earnings Table
  earningsTable: {
    marginBottom: 20,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    overflow: "hidden",
  },
  earningsHeader: {
    flexDirection: "row",
    backgroundColor: COLORS.primary,
    padding: 10,
  },
  earningsHeaderText: {
    fontSize: 10,
    fontWeight: "bold",
    color: COLORS.white,
  },
  earningsRow: {
    flexDirection: "row",
    padding: 10,
    borderBottom: `1px solid ${COLORS.border}`,
    backgroundColor: COLORS.white,
  },
  earningsRowAlt: {
    backgroundColor: COLORS.lightGray,
  },
  earningsName: {
    width: "70%",
    fontSize: 9,
    color: COLORS.dark,
  },
  earningsAmount: {
    width: "30%",
    fontSize: 9,
    textAlign: "right",
    fontWeight: "bold",
    color: COLORS.success,
  },

  // Deductions Table
  deductionsTable: {
    marginBottom: 20,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    overflow: "hidden",
  },
  deductionsHeader: {
    flexDirection: "row",
    backgroundColor: COLORS.error,
    padding: 10,
  },
  deductionsHeaderText: {
    fontSize: 10,
    fontWeight: "bold",
    color: COLORS.white,
  },
  deductionsRow: {
    flexDirection: "row",
    padding: 10,
    borderBottom: `1px solid ${COLORS.border}`,
  },
  deductionsName: {
    width: "70%",
    fontSize: 9,
    color: COLORS.dark,
  },
  deductionsAmount: {
    width: "30%",
    fontSize: 9,
    textAlign: "right",
    fontWeight: "bold",
    color: COLORS.error,
  },

  // Summary Section
  summarySection: {
    width: "100%",
    alignItems: "flex-end",
    marginTop: 8,
    marginBottom: 14,
  },

  summaryTable: {
    width: 220,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 6,
    overflow: "hidden",
  },

  summaryRow: {
    flexDirection: "row",
    alignItems: "center",
    minHeight: 32,
    borderBottom: `1px solid ${COLORS.border}`,
    backgroundColor: COLORS.white,
  },

  summaryLastRow: {
    borderBottom: "none",
  },

  summaryLabel: {
    width: "65%",
    fontSize: 9,
    color: COLORS.gray,
    paddingVertical: 8,
    paddingHorizontal: 12,
    backgroundColor: "#fafafa",
    fontWeight: "bold",
  },

  summaryValue: {
    width: "35%",
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "right",
    paddingVertical: 8,
    paddingHorizontal: 12,
  },

  // Net Salary Box
  netSalaryBox: {
    marginTop: 10,
    backgroundColor: COLORS.primaryLight,
    border: `1px solid ${COLORS.primary}`,
    borderRadius: 5,
    paddingVertical: 8,
    paddingHorizontal: 12,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  netSalaryLabel: {
    fontSize: 9,
    fontWeight: "bold",
    color: COLORS.primaryDark,
    letterSpacing: 0.8,
    marginBottom: 1,
  },

  netSalarySubtext: {
    fontSize: 6.5,
    color: COLORS.gray,
  },

  netSalaryValueContainer: {
    alignItems: "flex-end",
  },

  netSalaryValue: {
    fontSize: 16,
    fontWeight: "bold",
    color: COLORS.primaryDark,
  },

  netSalaryCurrency: {
    fontSize: 6.5,
    color: COLORS.gray,
    marginTop: 1,
  },

  // Footer
  footer: {
    borderTop: `1px solid ${COLORS.border}`,
    paddingTop: 15,
    alignItems: "center",
  },
  footerText: {
    fontSize: 8,
    color: COLORS.gray,
    marginBottom: 4,
  },
});

const formatCurrency = (amount) => {
  const num = parseFloat(amount || 0);
  return `Rs. ${num.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const getStatusStyle = (status) => {
  switch (status?.toLowerCase()) {
    case "approved":
      return { bg: "#dbeafe", color: "#1e40af", text: "APPROVED" };
    case "paid":
      return { bg: "#d1fae5", color: "#065f46", text: "PAID" };
    case "processed":
      return { bg: "#e0e7ff", color: "#3730a3", text: "PROCESSED" };
    default:
      return {
        bg: "#fee2e2",
        color: "#991b1b",
        text: (status || "PENDING").toUpperCase(),
      };
  }
};

const PayslipPDF = ({ data, month, year }) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const statusStyle = getStatusStyle(data?.status);

  // Prepare earnings data
  const earnings = [
    { label: "Basic Salary", value: data?.basic_salary },
    { label: "House Rent Allowance (HRA)", value: data?.hra },
    { label: "Conveyance Allowance", value: data?.conveyance },
    { label: "Education Allowance", value: data?.education_allowance },
    { label: "Transport Allowance", value: data?.transport_allowance },
    { label: "Fixed Allowance", value: data?.fixed_allowance },
    { label: "Bonus", value: data?.bonus },
    { label: "Overtime Amount", value: data?.overtime_amount },
    { label: "Telephone Reimbursement", value: data?.telephone_reimbursement },
    { label: "Fuel Reimbursement", value: data?.fuel_reimbursement },
    { label: "Driver Reimbursement", value: data?.driver_reimbursement },
  ].filter((item) => parseFloat(item.value || 0) > 0);

  const totalEarnings = earnings.reduce(
    (sum, item) => sum + parseFloat(item.value || 0),
    0,
  );

  // Prepare deductions data
  const deductions = [
    { label: "Provident Fund (12%)", value: data?.provident_fund },
    { label: "Professional Tax", value: data?.professional_tax },
    { label: "Tax Deducted at Source (TDS)", value: data?.tax_amount },
    { label: "Late Deduction", value: data?.late_deduction },
    { label: "Loan Installment", value: data?.loan_installment },
  ].filter((item) => parseFloat(item.value || 0) > 0);

  const totalDeductions = deductions.reduce(
    (sum, item) => sum + parseFloat(item.value || 0),
    0,
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.logoArea}>
            <View style={styles.logoBox}>
              <Text style={styles.logoText}>E</Text>
            </View>
            <View>
              <Text style={styles.companyNameText}> EBluesys</Text>
              <Text style={styles.companySubText}>
                Payroll Management System
              </Text>
            </View>
          </View>
          <View style={styles.titleArea}>
            <Text style={styles.payslipTitle}>PAYSLIP</Text>
            <Text style={styles.payslipMonth}>
              {months[(data?.month || month) - 1]} {data?.year || year}
            </Text>
          </View>
        </View>

        {/* Top Information Section */}
        <View
          style={{
            flexDirection: "row",
            gap: 14,
            marginBottom: 22,
          }}
        >
          {/* Employee Information */}
          <View
            style={{
              flex: 1,
              border: `1px solid ${COLORS.border}`,
              borderRadius: 8,
              overflow: "hidden",
            }}
          >
            {/* Heading */}
            <View
              style={{
                backgroundColor: COLORS.primaryLight,
                paddingVertical: 8,
                paddingHorizontal: 12,
                borderBottom: `1px solid ${COLORS.border}`,
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  color: COLORS.primaryDark,
                  letterSpacing: 0.5,
                }}
              >
                EMPLOYEE INFORMATION
              </Text>
            </View>

            {/* Body */}
            <View style={{ padding: 12 }}>
              {/* Row */}
              <View
                style={{
                  flexDirection: "row",
                  marginBottom: 10,
                }}
              >
                <View style={{ width: "42%" }}>
                  <Text style={styles.infoLabel}>Employee Name</Text>
                </View>

                <View style={{ width: "58%" }}>
                  <Text style={styles.infoValue}>
                    {data?.employee_name || "-"}
                  </Text>
                </View>
              </View>

              {/* Row */}
              <View
                style={{
                  flexDirection: "row",
                  marginBottom: 10,
                }}
              >
                <View style={{ width: "42%" }}>
                  <Text style={styles.infoLabel}>Department</Text>
                </View>

                <View style={{ width: "58%" }}>
                  <Text style={styles.infoValue}>
                    {data?.department_name || "-"}
                  </Text>
                </View>
              </View>

              {/* Row */}
              <View
                style={{
                  flexDirection: "row",
                }}
              >
                <View style={{ width: "42%" }}>
                  <Text style={styles.infoLabel}>Designation</Text>
                </View>

                <View style={{ width: "58%" }}>
                  <Text style={styles.infoValue}>
                    {data?.designation || "-"}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {/* Payment Information */}
          <View
            style={{
              flex: 1,
              border: `1px solid ${COLORS.border}`,
              borderRadius: 8,
              overflow: "hidden",
            }}
          >
            {/* Heading */}
            <View
              style={{
                backgroundColor: "#eff6ff",
                paddingVertical: 8,
                paddingHorizontal: 12,
                borderBottom: `1px solid ${COLORS.border}`,
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  color: COLORS.secondary,
                  letterSpacing: 0.5,
                }}
              >
                PAYMENT INFORMATION
              </Text>
            </View>

            {/* Body */}
            <View style={{ padding: 12 }}>
              {/* Row */}
              <View
                style={{
                  flexDirection: "row",
                  marginBottom: 10,
                }}
              >
                <View style={{ width: "42%" }}>
                  <Text style={styles.infoLabel}>Status</Text>
                </View>

                <View style={{ width: "58%" }}>
                  <View
                    style={[
                      styles.statusBadge,
                      { backgroundColor: statusStyle.bg },
                    ]}
                  >
                    <Text
                      style={[styles.statusText, { color: statusStyle.color }]}
                    >
                      {statusStyle.text}
                    </Text>
                  </View>
                </View>
              </View>

              {/* Row */}
              <View
                style={{
                  flexDirection: "row",
                  marginBottom: 10,
                }}
              >
                <View style={{ width: "42%" }}>
                  <Text style={styles.infoLabel}>Payment Date</Text>
                </View>

                <View style={{ width: "58%" }}>
                  <Text style={styles.infoValue}>
                    {formatDate(data?.payment_date)}
                  </Text>
                </View>
              </View>

              {/* Row */}
              <View
                style={{
                  flexDirection: "row",
                }}
              >
                <View style={{ width: "42%" }}>
                  <Text style={styles.infoLabel}>Reference No.</Text>
                </View>

                <View style={{ width: "58%" }}>
                  <Text style={styles.infoValue}>
                    {data?.payment_reference || "-"}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        {/* Earnings + Deductions Layout */}
        <View
          style={{
            flexDirection: "row",
            gap: 14,
            marginTop: 10,
            alignItems: "flex-start",
          }}
        >
          {/* LEFT - Earnings */}
          <View style={{ width: "48%" }}>
            <Text style={styles.sectionTitle}>EARNINGS</Text>

            <View
              style={{
                border: `1px solid ${COLORS.border}`,
                borderRadius: 4,
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: COLORS.primary,
                  paddingVertical: 7,
                  paddingHorizontal: 8,
                }}
              >
                <Text
                  style={[
                    styles.earningsHeaderText,
                    { width: "70%", fontSize: 8.5 },
                  ]}
                >
                  Description
                </Text>

                <Text
                  style={[
                    styles.earningsHeaderText,
                    {
                      width: "30%",
                      textAlign: "right",
                      fontSize: 8.5,
                    },
                  ]}
                >
                  Amount
                </Text>
              </View>

              {/* Rows */}
              {earnings.map((item, idx) => (
                <View
                  key={idx}
                  style={{
                    flexDirection: "row",
                    paddingVertical: 6,
                    paddingHorizontal: 8,
                    borderBottom:
                      idx !== earnings.length - 1
                        ? `0.7px solid ${COLORS.border}`
                        : "none",
                    backgroundColor: idx % 2 === 0 ? COLORS.white : "#fffbeb",
                  }}
                >
                  <Text
                    style={{
                      width: "70%",
                      fontSize: 8,
                      color: COLORS.dark,
                    }}
                  >
                    {item.label}
                  </Text>

                  <Text
                    style={{
                      width: "30%",
                      fontSize: 8,
                      textAlign: "right",
                      color: COLORS.success,
                      fontWeight: "bold",
                    }}
                  >
                    {formatCurrency(item.value)}
                  </Text>
                </View>
              ))}
            </View>
          </View>

          {/* RIGHT - Deductions + Reimbursements */}
          <View style={{ width: "48%" }}>
            <Text style={styles.sectionTitle}>DEDUCTIONS</Text>

            <View
              style={{
                border: `1px solid ${COLORS.border}`,
                borderRadius: 4,
                overflow: "hidden",
                marginBottom: 12,
              }}
            >
              {/* Header */}
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: COLORS.error,
                  paddingVertical: 7,
                  paddingHorizontal: 8,
                }}
              >
                <Text
                  style={[
                    styles.deductionsHeaderText,
                    { width: "70%", fontSize: 8.5 },
                  ]}
                >
                  Description
                </Text>

                <Text
                  style={[
                    styles.deductionsHeaderText,
                    {
                      width: "30%",
                      textAlign: "right",
                      fontSize: 8.5,
                    },
                  ]}
                >
                  Amount
                </Text>
              </View>

              {/* Rows */}
              {deductions.map((item, idx) => (
                <View
                  key={idx}
                  style={{
                    flexDirection: "row",
                    paddingVertical: 6,
                    paddingHorizontal: 8,
                    borderBottom:
                      idx !== deductions.length - 1
                        ? `0.7px solid ${COLORS.border}`
                        : "none",
                    backgroundColor: idx % 2 === 0 ? COLORS.white : "#fef2f2",
                  }}
                >
                  <Text
                    style={{
                      width: "70%",
                      fontSize: 8,
                      color: COLORS.dark,
                    }}
                  >
                    {item.label}
                  </Text>

                  <Text
                    style={{
                      width: "30%",
                      fontSize: 8,
                      textAlign: "right",
                      color: COLORS.error,
                      fontWeight: "bold",
                    }}
                  >
                    {formatCurrency(item.value)}
                  </Text>
                </View>
              ))}
            </View>

            {/* Reimbursement Mini Table */}
            <Text style={styles.sectionTitle}>REIMBURSEMENTS</Text>

            <View
              style={{
                border: `1px solid ${COLORS.border}`,
                borderRadius: 4,
                overflow: "hidden",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#0f766e",
                  paddingVertical: 7,
                  paddingHorizontal: 8,
                }}
              >
                <Text
                  style={{
                    width: "70%",
                    color: COLORS.white,
                    fontSize: 8.5,
                    fontWeight: "bold",
                  }}
                >
                  Type
                </Text>

                <Text
                  style={{
                    width: "30%",
                    color: COLORS.white,
                    fontSize: 8.5,
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  Amount
                </Text>
              </View>

              {[
                {
                  label: "Telephone",
                  value: data?.telephone_reimbursement,
                },
                {
                  label: "Fuel",
                  value: data?.fuel_reimbursement,
                },
                {
                  label: "Driver",
                  value: data?.driver_reimbursement,
                },
              ]
                .filter((item) => parseFloat(item.value || 0) > 0)
                .map((item, idx, arr) => (
                  <View
                    key={idx}
                    style={{
                      flexDirection: "row",
                      paddingVertical: 6,
                      paddingHorizontal: 8,
                      borderBottom:
                        idx !== arr.length - 1
                          ? `0.7px solid ${COLORS.border}`
                          : "none",
                      backgroundColor: idx % 2 === 0 ? COLORS.white : "#f0fdfa",
                    }}
                  >
                    <Text
                      style={{
                        width: "70%",
                        fontSize: 8,
                        color: COLORS.dark,
                      }}
                    >
                      {item.label}
                    </Text>

                    <Text
                      style={{
                        width: "30%",
                        fontSize: 8,
                        textAlign: "right",
                        color: "#0f766e",
                        fontWeight: "bold",
                      }}
                    >
                      {formatCurrency(item.value)}
                    </Text>
                  </View>
                ))}
            </View>
          </View>
        </View>

        {/* Bottom Summary Section */}
        <View
          style={{
            marginTop: 20,
            borderTop: `1px solid ${COLORS.border}`,
            paddingTop: 16,
          }}
        >
          {/* Totals */}
          <View style={styles.summarySection}>
            <View style={styles.summaryRow}>
              <Text style={styles.summaryLabel}>Total Earnings:</Text>
              <Text style={[styles.summaryValue, { color: COLORS.success }]}>
                {formatCurrency(totalEarnings)}
              </Text>
            </View>

            <View style={styles.summaryRow}>
              <Text style={styles.summaryLabel}>Total Deductions:</Text>
              <Text style={[styles.summaryValue, { color: COLORS.error }]}>
                {formatCurrency(totalDeductions)}
              </Text>
            </View>
          </View>

          {/* Net Salary */}
          <View style={styles.netSalaryBox}>
            <Text style={styles.netSalaryLabel}>NET SALARY PAYABLE</Text>

            <View style={{ alignItems: "flex-end" }}>
              <Text style={styles.netSalaryValue}>
                {formatCurrency(data?.net_salary)}
              </Text>

              <Text
                style={{
                  fontSize: 8,
                  color: COLORS.gray,
                  marginTop: 2,
                }}
              >
                Credited to Employee
              </Text>
            </View>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.footerText}>
            This is a computer-generated document. No signature is required.
          </Text>
          <Text style={styles.footerText}>
            Generated on: {new Date().toLocaleDateString("en-IN")}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default PayslipPDF;
